import React, { useState } from "react";
import {
  Container,
  Link,
  Box,
  Button,
  Flex,
  List,
  Text,
  Dropdown,
  Message,
  Heading
} from "samba-ui";
import styled from "styled-components";
import useTopChannels from "./hooks/useTopChannels";
import PageLoader from "./PageLoader";
import AreYouSureModal from "./AreYouSureModal";
import UpdateTopChannelModal from "./UpdateTopChannelModal";

const StyledFlex = styled(Flex)`
  opacity: ${p => (p.disabled ? 0.5 : 1)};
  pointer-events: {
    p=>p.disabled ? "none" : "auto";
  }
`;

const ManageTopChannels = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const isSuperOperator = user.role === "superoperator";
  const {
    loading,
    topChannels,
    countryOptions,
    selectedCountry,
    onCountryChange,
    add,
    update,
    deleteChannel,
    message,
    type
  } = useTopChannels();

  if (loading) {
    return <PageLoader />;
  }

  let _topChannels = topChannels;
  if (selectedCountry.value !== "ALL") {
    _topChannels = _topChannels.filter(
      t => t.country === selectedCountry.value
    );
  }

  const onDeleteClick = channel => {
    setSelectedChannel(channel);
    setIsOpen(true);
  };

  const onUpdateClick = channel => {
    setSelectedChannel(channel);
    setIsUpdateOpen(true);
  };

  const onDeleteChannel = async () => {
    await deleteChannel(selectedChannel.id);
    setSelectedChannel(null);
    setIsOpen(false);
  };

  const onAddSubmit = async body => {
    await add(body);
    setSelectedChannel(null);
    setIsUpdateOpen(false);
  };

  const onUpdateSubmit = async body => {
    await update(selectedChannel.id, body);
    setSelectedChannel(null);
    setIsUpdateOpen(false);
  };

  return (
    <Container maxWidth={2048} minWidth={960}>
      {message && <Message variant={type}>{message}</Message>}
      <Flex>
        <Box width="calc(100% - 300px)" pr={4}>
          <Flex>
            <Heading>Top Channels</Heading>
          </Flex>
          <List.Header borderColor="#d6d6d6 !important">
            <Flex justifyContent="space-between" alignItems="center">
              <Box width={1 / 7}>Country</Box>
              <Box width={1 / 7}>SSID</Box>
              <Box width={1 / 7}>Network Call Sign</Box>
              <Box width={1 / 7}>SambaTV Call Sign</Box>
              <Box width={1 / 7}>Updated By</Box>
              <Box width={2 / 7} />
            </Flex>
          </List.Header>
          {_topChannels.map((channel, index) => {
            return (
              <List.Item borderColor="#d6d6d6 !important" key={index}>
                <Flex alignItems="center" justifyContent="space-between">
                  <Box width={1 / 7}>{channel.country}</Box>
                  <Box width={1 / 7}>{channel.ssid}</Box>
                  <Box width={1 / 7}>{channel.networkCallSign}</Box>
                  <Box width={1 / 7}>{channel.sambaCallSign}</Box>
                  <Box width={1 / 7}>{channel.updatedBy}</Box>
                  <StyledFlex
                    width={2 / 7}
                    justifyContent="space-around"
                    disabled={isSuperOperator}
                  >
                    <Link
                      fontWeight={500}
                      color="alert"
                      onClick={() => onDeleteClick(channel)}
                    >
                      Delete
                    </Link>
                    <Link
                      fontWeight={500}
                      color="primary"
                      onClick={() => onUpdateClick(channel)}
                    >
                      Update
                    </Link>
                  </StyledFlex>
                </Flex>
              </List.Item>
            );
          })}
        </Box>
        <Box width={300} ml={2} mt={5}>
          <Box>
            <Text fontSize={1} fontWeight={500}>
              Country
            </Text>
            <Dropdown
              options={countryOptions}
              selected={selectedCountry}
              onSelect={onCountryChange}
            />
          </Box>
          <Box mt={4}>
            <Button
              disabled={isSuperOperator}
              style={{ width: "100%" }}
              onClick={() => setIsUpdateOpen(true)}
            >
              Add New
            </Button>
          </Box>
        </Box>
      </Flex>
      <AreYouSureModal
        title="Are you sure you want to delete the top channel?"
        body="Please confirm that you want to delete"
        isOpen={isOpen}
        onClose={() => {
          setSelectedChannel(null);
          setIsOpen(false);
        }}
        onSubmit={onDeleteChannel}
      />
      <UpdateTopChannelModal
        isOpen={isUpdateOpen}
        selectedTopChannel={selectedChannel}
        allSSids={
          _topChannels && _topChannels.length
            ? _topChannels.map(t => t.ssid)
            : []
        }
        onUpdate={onUpdateSubmit}
        onAdd={onAddSubmit}
        countryOptions={countryOptions}
        onClose={() => {
          setSelectedChannel(null);
          setIsUpdateOpen(false);
        }}
      />
    </Container>
  );
};

export default ManageTopChannels;
